import api from "./api/api";

const ConfigService = {
  configs: async () => {
    try {
      const res = await api.get(`/configs`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default ConfigService;
